$(function () {
    $('select[name="sltRestriction"]').on('change', function () {
        const url = new URL(window.location.href);
        const selectedValue = $(this).find(':selected').val();
        url.searchParams.set('restriction', selectedValue);
        window.location.href = url.href;
    });
});
